const inkeep_ai_bot = {
    intro_message: 'Hi，我是Logto人工智能！\n\n我是一个在文档、帮助文章和其他内容上训练的人工智能助手。\n\n问我有关 `Logto` 的任何问题。',
    chat_placeholder: '向Logto人工智能询问你的问题，获取详细指南',
    disclaimer_label: 'Logto人工智能免责声明',
    disclaimer_tooltip: '回复内容由人工智能生成，可能需要进一步核实。',
    example_questions_label: '示例问题',
    example_questions: ['Logto 设置的快速入门指南', '配置多租户架构', '如何集成用户档案？'],
    stop: '停止',
    clear: '重新开始',
    get_help: '获取帮助',
    copy_chat: '复制',
    ask_ai_label: '询问人工智能',
    contact: '联系我们',
    discord: 'Discord社区',
};
export default Object.freeze(inkeep_ai_bot);
